import React, { useEffect } from 'react'
import Sidebar from '../Sidebar/Sidebar'
import "./Attendance.css"


const Attendance = () => {
    useEffect(() => {
        const token = localStorage.getItem("authToken"); 
        console.log(token)
    },[])
  return (
      <>
          
          <div className="attendee">
              <Sidebar />
              <div className="attendacebutton">
              <button>
                  Add
              </button>
             </div>
          </div>
          
          

    </>
  )
}

export default Attendance
